import { Form } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import { CompactFieldLabel } from "./formcompactselect.jsx";
import styled from "styled-components";

const StyledTextArea = styled(Form.Control).attrs({
  className: "form-control",
})`
  width: auto;
  height: auto;
  border: 0;
  background-color: white;
  padding: 0;
  font:
    400 12px / 12px Borna,
    "Segoe UI",
    sans-serif;
`;

export const FormCompactInput = ({
  name,
  label,
  formGroupProps,
  inputProps,
  required,
  disabled,
  customErrorMessage,
  additionalClassnames,
  Icon,
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: required }}
      render={({
        field: { value, onChange, disabled: globalDisabled, onBlur, ref },
        fieldState: { error, isDirty },
      }) => {
        const errorType = error?.type;

        const helperText = () => {
          if (errorType === "required") {
            return "The field is required";
          }
          return errorType && customErrorMessage?.[errorType] ? customErrorMessage[errorType] : error?.message;
        };

        return (
          <Form.Group
            required={required}
            className={`d-flex flex-row gap-1 align-items-center ${additionalClassnames ?? ""}`}
            controlId={`select-${name}`}
            {...formGroupProps}
          >
            {label && (
              <CompactFieldLabel htmlFor={`select-${name}`}>
                {Icon && <Icon />}
                {`${label}: ${required ? " *" : ""}`}
              </CompactFieldLabel>
            )}
            <StyledTextArea
              id={`select-${name}`}
              value={value}
              onChange={onChange}
              as="input"
              required={required}
              rows={1}
              active={isDirty}
              onBlur={onBlur}
              disabled={disabled || globalDisabled}
              ref={ref}
              placeholder={`${label} ${required ? " *" : ""}`}
              {...inputProps}
            />
            {error && (
              <Form.Control.Feedback type="invalid" className="d-block mb-1">
                {helperText()}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        );
      }}
    />
  );
};
